import { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modal';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import Switcher from '../Form/Fields/Switcher';
import Button from '../Form/Button';
import './CreateProductModal.scss';
import { API_BASE_URL } from '../../api';

const PatientAddressModal = ({ show, onClose, patientId, address, forceDefault, onSuccess }) => {
    const modalRef = useRef();
    const [isLoading, setIsLoading] = useState(false);

    const isEditing = !!address?.id;

    const handleSubmit = (data) => {
        setIsLoading(true);

        const payload = {
            addressLine1: data.addressLine1,
            addressLine2: data.addressLine2,
            city: data.city,
            postalCode: data.postalCode,
            country: data.country,
            default: !!data.isDefault,
        };

        const url = isEditing
            ? `${API_BASE_URL}/api/v1/patients/${patientId}/addresses/${address.id}`
            : `${API_BASE_URL}/api/v1/patients/${patientId}/addresses`;
        const method = isEditing ? 'put' : 'post';

        axios({ method, url, data: payload, withCredentials: true })
            .then(() => {
                toast.success(isEditing ? 'Adresse mise à jour avec succès !' : 'Adresse ajoutée avec succès !');
                if (onSuccess) onSuccess();
            })
            .catch(() => toast.error('Erreur lors de l\'enregistrement de l\'adresse'))
            .finally(() => setIsLoading(false));
    };

    const defaultValues = {
        addressLine1: address?.addressLine1 || '',
        addressLine2: address?.addressLine2 || '',
        city: address?.city || '',
        postalCode: address?.postalCode || '',
        country: address?.country || 'Maroc',
        isDefault: forceDefault || address?.default || false,
    };

    return (
        <Modal
            ref={modalRef}
            id="patientAddressModal"
            classSize="modal-dialog-centered"
            title={isEditing ? "Modifier l'adresse" : 'Ajouter une adresse'}
            icon={faMapMarkerAlt}
            iconBg="#eff6ff"
            iconColor="#2563eb"
            show={show}
            onClose={onClose}
            footer={
                <Button
                    isLoading={isLoading}
                    loadingMessage="Enregistrement…"
                    type="submit"
                    form="patientAddressForm"
                    className="btn btn-primary w-100 fw-bold"
                >
                    Enregistrer
                </Button>
            }
        >
            <Form id="patientAddressForm" onSubmit={handleSubmit} defaultValues={defaultValues} key={address?.id || 'new'}>
                <div className="cdm-section">
                    <p className="cdm-section__label">Adresse principale</p>
                    <div className="cdm-grid-2 mb-2" style={{ gridTemplateColumns: '2fr 1fr' }}>
                        <div>
                            <label className="cdm-field-label">Adresse <span className="text-danger">*</span></label>
                            <InputText
                                name="addressLine1"
                                placeholder="1234 Rue Principale"
                                validationRules={{ required: "L'adresse est requise" }}
                            />
                        </div>
                        <div>
                            <label className="cdm-field-label">Code postal</label>
                            <InputText name="postalCode" placeholder="10000" />
                        </div>
                    </div>
                    <div className="mb-2">
                        <label className="cdm-field-label">Complément d'adresse</label>
                        <InputText name="addressLine2" placeholder="Appartement, étage, bâtiment…" />
                    </div>
                    <div className="cdm-grid-2">
                        <div>
                            <label className="cdm-field-label">Ville</label>
                            <InputText name="city" placeholder="Casablanca" />
                        </div>
                        <div>
                            <label className="cdm-field-label">Pays</label>
                            <InputText name="country" placeholder="Maroc" />
                        </div>
                    </div>
                </div>

                <div className="cdm-section" style={{ marginBottom: 0 }}>
                    <p className="cdm-section__label">Options</p>
                    <div className="d-flex align-items-center gap-3">
                        <Switcher name="isDefault" size="mini" />
                        <span className="cdm-field-label mb-0" style={{ fontWeight: 500, fontSize: 13, color: '#374151' }}>
                            Définir comme adresse par défaut
                        </span>
                    </div>
                </div>
            </Form>
        </Modal>
    );
};

export default PatientAddressModal;
